<template>
  <div>
      <div class="form-group">
        <label>Overall story score</label>
      </div>

      <div>
          <div class="form-group">
            <label>Grammar</label>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios1" value="option1" checked="">
                    Perfect - no major complains
                </label>
            </div>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios2" value="option2">
                    Good - some minor errors, but nothing to worry about
                </label>
            </div>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios3" value="option3">
                    Moderate - readable, but errors can be distracting sometimes
                </label>
            </div>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios4" value="option4">
                    Bad - a lot of errors, needs work
                </label>
            </div>
        </div>
      </div>

            <div>
          <div class="form-group">
            <label>Text</label>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios1" value="option1" checked="">
                    Option one is this and that—be sure to include why it's great
                </label>
            </div>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios2" value="option2">
                    Option two can be something else and selecting it will deselect option one
                </label>
            </div>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled="">
                    Option three is disabled
                </label>
            </div>
        </div>
      </div>

            <div>
          <div class="form-group">
            <label>Text</label>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios1" value="option1" checked="">
                    Option one is this and that—be sure to include why it's great
                </label>
            </div>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios2" value="option2">
                    Option two can be something else and selecting it will deselect option one
                </label>
            </div>
            <div class="radio">
                <label>
                    <input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled="">
                    Option three is disabled
                </label>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "FimCommentGenerator",
  data: function(){
      return {

      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FimCommentGenerator.vue